module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['add-seller-account', _vm.cssClass]
  }, [_c('amazon-region-connect', {
    attrs: {
      "show-nickname": _vm.showNickname,
      "show-pricing-message": !_vm.$root.hasDailyPricing,
      "redirect-path": _vm.$route.path
    },
    on: {
      "error": _vm.onConnectError
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3562ec3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/AddSellerAccount.vue
// module id = 746
// module chunks = 2